
Directives.ReportsAnalyticsChartDirective =  function ReportsAnalyticsChartDirective(){

    // @ngInject
    function ReportsAnalyticsChartDirectiveControllerFunc($element, Chart, $scope, $injector, moment){

        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'ReportsAnalyticsChartDirectiveController';
        var self = this;

        var chartElement = $element.find('canvas:first-of-type').get(0);

        this.drawGraph = function drawGraph(animate) {
            var dataset1, dataset2, date, graph_ctx, max_value, num_of_steps, period, period_entries, scale_step, _i, _len;
            var colorLead = "#f0c30d";
            var colorBooked = "#6EE59A";
            period_entries = this.yearData.period_entries;
            var data = {};
            data.labels = [];
            data.datasets = [];
            dataset1 = {
                backgroundColor: colorLead,//"#F5D329",
                strokeColor:colorLead,// "#F5D329",
                data: []
            };
            data.datasets[0] = dataset1;
            dataset2 = {
                backgroundColor: colorBooked,
                strokeColor: colorBooked,//"#70BF40",
                data: []
            };
            data.datasets[1] = dataset2;
            max_value = 0;
            var graph_options = null;
            if (period_entries) {
                for (_i = 0, _len = period_entries.length; _i < _len; _i++) {
                    period = period_entries[_i];
                    date = new Date(period.timestamp);
                    data.labels.push(moment(date).format('MMMM'));
                    dataset1.data.push(period.files_sent);
                    dataset2.data.push(period.files_booked);
                    max_value = Math.max(max_value, period.files_sent, period.files_booked);
                }
                scale_step = 1;
                if (max_value >= 120) {
                    scale_step = 20;
                }else if (max_value >= 60) {
                    scale_step = 10;
                }else if (max_value >= 20) {
                    scale_step = 5;
                } else if (max_value >= 10) {
                    scale_step = 2;
                }
                num_of_steps = (max_value + 1) / scale_step;
                graph_options = {
                    legend: { display: false},
                    scaleOverlay: false,
                    scaleOverride: true,
                    scaleSteps: num_of_steps,
                    scaleStepWidth: scale_step,
                    scaleStartValue: 0,
                    scaleLineColor: "rgba(0,0,0,.1)",
                    scaleLineWidth: 1,
                    scaleShowLabels: true,
                    scaleLabel: "<%=value%>",
                    scaleFontFamily: "'Arial'",
                    scaleFontSize: 12,
                    scaleFontStyle: "normal",
                    scaleFontColor: "#666",
                    scaleShowGridLines: false,
                    scaleGridLineColor: "rgba(0,0,0,.05)",
                    scaleGridLineWidth: 1,
                    barShowStroke: true,
                    barStrokeWidth: 2,
                    barValueSpacing: 5,
                    barDatasetSpacing: 2,
                    tooltipEvents: ["mousemove"],
                    tooltipFillColor: "rgba(0,0,0,0.8)",
                    tooltipFontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
                    tooltipFontSize: 14,
                    tooltipFontStyle: "normal",
                    tooltipFontColor: "#fff",
                    tooltipTitleFontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
                    tooltipTitleFontSize: 14,
                    tooltipTitleFontStyle: "bold",
                    tooltipTitleFontColor: "#fff",
                    tooltipYPadding: 6,
                    tooltipXPadding: 6,
                    tooltipCaretSize: 8,
                    tooltipCornerRadius: 6,
                    tooltipXOffset: 10,
                    tooltipTemplate: "<%if (label){%><%=label%>: <%}%><%= value %>",
                    multiTooltipTemplate: "<%= value %>",
                    animation: animate,
                    animationSteps: 60,
                    animationEasing: "easeOutQuart",
                    onAnimationComplete: function() {},
                    onAnimationProgress: function() {},
                    responsive: true,
                    maintainAspectRatio: false,
                    showTooltips: true
                };
            }
            if (this.barGraph != null) {
                this.barGraph.destroy();
            }
            graph_ctx = chartElement.getContext("2d");
            graph_ctx.clearRect(0, 0, chartElement.width, chartElement.height);

            this.barGraph = new Chart(graph_ctx, {
                // The type of chart we want to create
                type: 'bar',

                // The data for our dataset
                data: data,

                // Configuration options go here
                options: graph_options
            });

        };

        this.drawGraph(true);

        $scope.$watch('analyticsChartVm.yearData', function (newVal){
           self.drawGraph(false);
        });
    }

    var ReportsAnalyticsChartDirectiveController = Class(Controllers.BaseController, {
        constructor: ReportsAnalyticsChartDirectiveControllerFunc
    });
    return {
        scope:{
            yearData: '=analyticsReportYearData'
        },

        templateUrl : 'angular/app/modules/core/features/reports/analytics/reports_analytics_chart_directive_template.html',
        controller : ReportsAnalyticsChartDirectiveController,
        controllerAs : 'analyticsChartVm',
        bindToController : true
    };
};